import { defineStore } from 'pinia'
import { getImagePath } from '@/utils/utils'

export const usePaymentProfileStore = defineStore('PaymentProfileStore', {
  state: () => ({
    payment_methods: [
      {
        value: 'bancontactmrcash',
        label: 'Bancontact',
        image: getImagePath('payments/bancontact-logo.svg')
      },
      {
        value: 'bancontact',
        label: 'Bancontact / Maestro',
        image: getImagePath('payments/bancontact-logo.svg')
      },
      {
        value: 'maestro',
        label: 'Maestro',
        image: getImagePath('payments/maestro-logo.svg')
      },
      {
        value: 'mae',
        label: 'Maestro',
        image: getImagePath('payments/maestro-logo.svg')
      },
      {
        value: 'three_d_secure',
        label: 'Credit card (Visa / MasterCard...)',
        image: getImagePath('payments/three-d-secure-logo.svg')
      },
      {
        value: 'visa',
        label: 'VISA',
        image: getImagePath('payments/visa-logo.svg')
      },
      {
        value: 'mastercard',
        label: 'Mastercard',
        image: getImagePath('payments/mastercard-logo.svg')
      },
      {
        value: 'sofort',
        label: 'SOFORT',
        image: getImagePath('payments/sofort-logo.svg')
      },
      {
        value: 'ideal',
        label: 'iDEAL',
        image: getImagePath('payments/ideal-logo.svg')
      },
      {
        value: 'sepa_debit',
        label: 'SEPA debit',
        image: getImagePath('payments/sepa-direct.svg')
      },
      {
        value: 'sepa_dd',
        label: 'SEPA debit',
        image: getImagePath('payments/sepa-direct.svg')
      },
      {
        value: 'test_payment',
        label: 'Test payment',
        available: false,
        image: getImagePath('payments/test-payment-logo.svg')
      },
      {
        value: 'payconiq',
        label: 'Payconiq',
        image: getImagePath('payments/payconiq-logo.svg')
      },
      {
        value: 'offline',
        label: 'Offline',
        image: getImagePath('payments/offline-logo.svg')
      },
      {
        value: 'twikey',
        label: 'Twikey',
        image: getImagePath('payments/twikey-logo.svg')
      },
      {
        value: 'belfius',
        label: 'Belfius Pay Button',
        image: getImagePath('payments/belfius-pay-logo.svg')
      },
      {
        value: 'KBCPaymentButton',
        label: 'KBC/CBC Pay Button',
        image: getImagePath('payments/kbc-pay-logo.svg')
      },
      {
        value: 'paypal',
        label: 'PayPal',
        image: getImagePath('payments/paypal-logo.svg')
      },
      {
        value: 'eps',
        label: 'EPS',
        image: getImagePath('payments/eps-logo.svg')
      },
      {
        value: 'card',
        label: 'Credit card (Visa / MasterCard...)',
        image: getImagePath('payments/three-d-secure-logo.svg')
      },
      {
        value: 'twint',
        label: 'TWINT',
        image: getImagePath('payments/twint-logo.svg')
      },
      {
        value: 'google_pay',
        label: 'Google Pay',
        image: getImagePath('payments/google-pay-logo.svg')
      },
      {
        value: 'apple_pay',
        label: 'Apple Pay',
        image: getImagePath('payments/apple-pay-logo.svg')
      }
    ]
  })
})